import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Card, Spinner, Button } from 'react-bootstrap';
import ProgressBar from 'react-animated-progress-bar';
import { Animated } from "react-animated-css";
import { Profile } from '@styled-icons/icomoon/Profile';
import { EmojiSad } from '@styled-icons/entypo/EmojiSad';
import { FilePdf } from '@styled-icons/boxicons-solid/FilePdf';

import { novoatualiza as novoatualizapedido } from '../../../actions/pedidos/pedidos';
import { notificaoconfirmacao, credencialTodosPedidosPdfLink } from '../../../actions/credenciamento/credencial';
import { pesquisaEmailRenderiza } from '../../../actions/html/modelos';
import { pesquisa as pesquisatraducoes } from '../../../actions/traducoes/traducoes';

//Utils
import { 
    getEvento, 
    getLinguagemCred, 
    setEmailConfirmacaoCred, 
    getEmailConfirmacaoCred, 
    setLogoutusercred, 
    getCredencialPronta,
    getCategoriaCredDescricao,
    getCategoriaCred,
    getUserProduct,
    removeUserProduct,
    setPedidoConfirmado,
    getPedidoConfirmado,
    getAcessoLinkCategoriaDireto
    } from '../../../utils/eventosessioncred';

import { getTraducaoTrocaPor as trad } from '../../../utils/getTraducoes';

import './progressBarStyle.css';

const CredencialComum = (props) => {

    const [emailEnviado, setEmailEnviado] = useState(null);
    const [resultpedido, setResultPedido] = useState(null);
    const [emailModelo, setEmailModelo] = useState(false);
    const [credencial_bto_pdf, setCredencialPdf] = useState({result: false});
        
    const evento = getEvento();
    const credencial = getCredencialPronta();
    console.log(credencial);

    const credencial_pedido = {...credencial};
    delete credencial_pedido.evento;
    delete credencial_pedido.questionario;
    
    const email_enviado = getEmailConfirmacaoCred();

    const handleDadosBasicoCredencial = () => {

        const pedido_confirmado = getPedidoConfirmado();

        const credencial_dados = {
            idpromotora: evento.idpromotora,
            idevento: evento.idevento,
            linguagem: getLinguagemCred(),
            aplicacao: 'credenciamento',
            categoriaform: getCategoriaCred(),
            jsoncredenciais: JSON.stringify({
                id: credencial.idcredencial,
                nome: credencial.fisica.nome+' '+credencial.fisica.sobrenome,
                email: credencial.fisica.email,
                empresa: credencial.fisica.juridica.razaosocial,
                cargo: credencial.cargocredencial?(credencial.cargocredencial.outroscargos!==null?credencial.cargocredencial.outroscargos:credencial.cargocredencial.cargo.portugues):(credencial.fisica.cargo?(credencial.fisica.outroscargos!==null?credencial.fisica.outroscargos:credencial.fisica.cargo.portugues):null),
                codigodebarras: credencial.codigodebarras,
                produto: {categoria: getCategoriaCredDescricao()[`descricao_${getLinguagemCred()}`]},
                pedido: {produto: pedido_confirmado&&pedido_confirmado[0]?pedido_confirmado[0].inscritoitensescolhidos[0].sub_itens.descricao_credencial:null},
            })
        }
        return credencial_dados;
    }
    
    const handleSair = () => {
        setLogoutusercred();
        console.log(getAcessoLinkCategoriaDireto());
        if(getAcessoLinkCategoriaDireto() !== false&&getAcessoLinkCategoriaDireto() !== 'false'){
            props.history.push(`/credenciamento/${evento.promotora}/${evento.ideventocriptografado}/${getAcessoLinkCategoriaDireto()}`);
        }else{
            props.history.push(`/credenciamento/${evento.promotora}/${evento.ideventocriptografado}`);
        }
    }

    const handleConfirmaPedido = async (pedido = {}) => {
        const result = await props.novoatualizapedido({
            idpromotora: evento.idpromotora,
            idevento: evento.idevento,
            ...pedido
        });
        setPedidoConfirmado(result);
        setResultPedido(result);            
    }

    const getModeloEmailCredencial = async () => {
        const result = await props.pesquisaEmailRenderiza({idpromotora: evento.idpromotora, idevento: evento.idevento, idfisica: credencial.fisica.idfisica, tipo: `CONFIRMACAO_VIS_${getLinguagemCred().toUpperCase()}`});
        setEmailModelo(result.result?result:false);
        return result;
    }

    const handlePesquisaPdf = async () => {        
        const cred = handleDadosBasicoCredencial();
        if(!cred.idpromotora){
            return false;
        }

        const idcredencial_string = `${credencial.idcredencial}`;
        setCredencialPdf(await props.credencialTodosPedidosPdfLink({
            idpromotora: evento.idpromotora,
            idevento: evento.idevento,
            linguagem: getLinguagemCred(),
            aplicacao: 'credenciamento',
            categoriaform: getCategoriaCred(),
            idcredencial: Buffer.from(idcredencial_string).toString('base64')
        }));
        return true;
    }

    const getNotificacao = async () => {
        const cred = handleDadosBasicoCredencial();
        if(cred&&cred.idpromotora){
            const result = await props.notificaoconfirmacao(cred);
            setEmailEnviado(result.result);
        }        
        setEmailConfirmacaoCred('1');        
    }

    const loadTraducao = async () => {
        await props.pesquisatraducoes({
                idpromotora: evento.idpromotora,
                idevento: evento.idevento,
                wherein: JSON.stringify({ 
                    campo: 'identificador', 
                    valores: ['passo1']
                })
            }
        );
    }

    const handlePrintPdf = () => {
        const idcredencial_string = Buffer.from(`${credencial.idcredencial}`).toString('base64');
        const params = `?idpromotora=${evento.idpromotora}&idevento=${evento.idevento}&linguagem=${getLinguagemCred()}&aplicacao=credenciamento&idcredencial=${idcredencial_string}&categoriaform=${getCategoriaCred()}`;
        const url = `cidtechweb/api/credenciais/credencial/link/impressao${params}`;
        const link = `${window.location.protocol}//${window.location.host}/${url}`;            
        window.open(link, '_blank').focus();
    }

    useEffect(() => {
        getModeloEmailCredencial();           
        loadTraducao();
        const carrinho = getUserProduct();
        const pedido_aberto = {
            ...carrinho,
            credencial: credencial_pedido
        };
        
        if(pedido_aberto && pedido_aberto.pedido){
            handleConfirmaPedido(pedido_aberto);
            removeUserProduct();
        }
    },[]);

    useEffect(() => {        
        handlePesquisaPdf();
        console.log(email_enviado);
        if(email_enviado!=='1'){            
            getNotificacao();
        }
    },[resultpedido])

    if(!props.trads.length){
        return null;
    }    
    
    return (
        <Card className="border-0 text-center w-100 p-3" style={{margin: "auto"}}>
            <Card.Header><Profile size="50" /></Card.Header>
            <Card.Title className="mt-4 mb-4">{trad(props.trads,'CREDFINISHED',getLinguagemCred())}</Card.Title>
            {credencial_bto_pdf.result===false?null:
            <Button block onClick={handlePrintPdf} className="mb-1"><FilePdf size="50" />Clique aqui para baixar sua Credencial</Button>
            }
            {emailEnviado!==null?
                emailEnviado===true?
                <Card className="border-0 text-center">
                    <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={true} animationInDuration={2000}>                
                        <ProgressBar width="230" trackWidth="20" percentage="100" trackPathColor="transparent" bgColor="#333333" />
                        {trad(props.trads,'MSGEMAILSENT',getLinguagemCred())}
                    </Animated>                
                </Card>
                :
                <>
                <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={true} animationInDuration={2000}>                
                    <EmojiSad size="50" />
                    {trad(props.trads,'MSGEMAILSENTBAD',getLinguagemCred())}
                </Animated>                
                </>
                :
                email_enviado!=='1'?
                <Card className="border-0 text-center">
                    <small>{trad(props.trads,'MSGSENDING',getLinguagemCred())}</small>
                    <Spinner animation="border" style={{margin: "auto"}} />
                </Card>
                :null
            }
            {resultpedido!==null&&resultpedido.result===false?
                <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={true} animationInDuration={2000}>                
                <EmojiSad size="50" />
                    {trad(props.trads,'MSGEPEDIDOBAD',getLinguagemCred())}
                </Animated>
                :
                null
            }
            {emailModelo===false?<Spinner animation="border" />:null}
            <Card dangerouslySetInnerHTML={{__html: emailModelo!==false?emailModelo.corpoemail:''}} />
            <Button block  className="mt-4" onClick={handleSair}>{trad(props.trads,'BTOSAIR',getLinguagemCred())}</Button>
        </Card>
    )
}

const mapStateToProps = (state) => {
    return {        
        pendingTasks: state.pendingTasks,
        trads: state.reducerTraducoes,
    }
}

export default connect(mapStateToProps,{
    notificaoconfirmacao,
    pesquisaEmailRenderiza,
    pesquisatraducoes,
    credencialTodosPedidosPdfLink,
    novoatualizapedido
})(withRouter(CredencialComum));